/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_LeadInputs */



/**
* | output |
* | --- |
* | "AWP Marine Consultancy has carried out inspections on behalf of OCIMF members and RightShip since 2010. Honest, safety-led work, wherever in the world we ope..." |
*
* @param {About_LeadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_lead = /** @type {((inputs?: About_LeadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_LeadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("自 2010 年起，AWP Marine Consultancy 一直代表 OCIMF 成员和 RightShip 开展检查。无论在世界何处，我们都秉持诚信、以安全为先。")
	return /** @type {LocalizedString} */ ("AWP Marine Consultancy has carried out inspections on behalf of OCIMF members and RightShip since 2010. Honest, safety-led work, wherever in the world we operate.")
});